<div class="content-center" flex-gt-sm="90" flex-gt-md="80">
	<div layout="column">
		<div class="title md-display-1 tc-grey-500 pad-top" layout="row">
			<span i18n>Your Profile</span>
			<span flex></span>
			<button mat-icon-button (click)="reloadPage()">
				<mat-icon>loop</mat-icon>
			</button>
		</div>
		<p class="caption mat-caption tc-grey-700 pad-bottom-sm" i18n>View and update your profile.</p>
	</div>

	<mat-accordion *ngIf="item">
		<!-- #region Number -->
		<mat-expansion-panel hideToggle="true">
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" i18n>Customer number</mat-panel-title>
				<mat-panel-description>{{item.number}}</mat-panel-description>
			</mat-expansion-panel-header>
		</mat-expansion-panel>
		<!-- #endregion -->

		<div *ngIf="item.type == CustomerType.Commercial">
			<!-- #region Company -->
			<mat-expansion-panel>
				<mat-expansion-panel-header collapsedHeight="50px">
					<mat-panel-title flex="35" i18n>Company</mat-panel-title>
					<mat-panel-description>
						<span class="na">{{item.company}}</span>
					</mat-panel-description>
				</mat-expansion-panel-header>
				<form #formCompany="ngForm" novalidate>
					<div layout-gt-sm="row" layout="column">
						<mat-form-field flex layout-margin>
							<mat-label i18n>Company</mat-label>
							<input matInput name="company" [(ngModel)]="item.company" #company="ngModel" placeholder="Company" i18n-placeholder required>
							<mat-error *ngIf="company.errors?.required"><span i18n>Company</span><span i18n> is required</span></mat-error>
						</mat-form-field>
					</div>
				</form>
				<mat-action-row>
					<button mat-flat-button color="primary" [disabled]="!formCompany.valid || isSaving" (click)="patch(['company'])" i18n>Save</button>
					<span flex></span>
				</mat-action-row>
			</mat-expansion-panel>
			<!-- #endregion -->

			<!-- #region CompanyEmail -->
			<mat-expansion-panel>
				<mat-expansion-panel-header collapsedHeight="50px">
					<mat-panel-title flex="35" i18n>Company Email</mat-panel-title>
					<mat-panel-description>{{item.companyEmail}}</mat-panel-description>
				</mat-expansion-panel-header>
				<form #formCompanyEmail="ngForm" novalidate>
					<div layout-gt-sm="row" layout="column">
						<mat-form-field flex layout-margin>
							<mat-label i18n>Company Email</mat-label>
							<input matInput type="email" name="companyEmail" [(ngModel)]="item.companyEmail" #companyEmail="ngModel" readonly="true" required email placeholder="Company Email" i18n-placeholder>
							<mat-error *ngIf="companyEmail.errors?.required"><span i18n>Company Email</span><span i18n> is required</span></mat-error>
							<mat-error *ngIf="!companyEmail.errors?.required && companyEmail.errors?.email"><span i18n>Email</span><span i18n> is invalid</span></mat-error>
						</mat-form-field>
					</div>
				</form>
				<mat-action-row>
					<button mat-flat-button color="primary" [disabled]="!formCompanyEmail.valid || isSaving" (click)="patch(['companyEmail'])" i18n>Save</button>
					<span flex></span>
				</mat-action-row>
			</mat-expansion-panel>
			<!-- #endregion -->

			<!-- #region Company Phone -->
			<mat-expansion-panel>
				<mat-expansion-panel-header collapsedHeight="50px">
					<mat-panel-title flex="35">Company Phone</mat-panel-title>
					<mat-panel-description>
						<span>{{item.companyPhoneNumber}}</span>
					</mat-panel-description>
				</mat-expansion-panel-header>
				<form #formCompanyPhone="ngForm" novalidate>
					<div layout-gt-sm="row" layout="column">
						<mat-form-field flex layout-margin>
							<mat-label i18n>Phone number</mat-label>
							<input matInput name="companyPhoneNumber" [(ngModel)]="item.companyPhoneNumber" #companyPhoneNumber="ngModel" required placeholder="Phone number" i18n-placeholder>
							<mat-error *ngIf="companyPhoneNumber.errors?.required"><span i18n>Phone number</span><span i18n> is required</span></mat-error>
						</mat-form-field>
					</div>
				</form>
				<mat-action-row>
					<button mat-flat-button color="primary" [disabled]="!formCompanyPhone.valid || isSaving" (click)="patch(['companyPhoneNumber'])" i18n>Save</button>
					<span flex></span>
				</mat-action-row>
			</mat-expansion-panel>
			<!-- #endregion -->
		</div>

		<!-- #region Salutation & Title -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35"><span i18n>Salutation</span>&nbsp;&amp;&nbsp;<span i18n>Title</span></mat-panel-title>
				<mat-panel-description><span i18n>{item.salutation | enum:Salutation, select, salutation {salutation} other {{{item.salutation | enum:Salutation}}}}</span>&nbsp;{{item.title}}</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formSalutationTitle="ngForm" novalidate>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex layout-margin>
						<mat-label i18n>Salutation</mat-label>
						<vd-select [(ngModel)]="item.salutation" [enum]="Salutation" name="salutation" #salutation="ngModel" placeholder="Salutation" i18n-placeholder required flex></vd-select>
						<mat-error *ngIf="salutation.errors?.required"><span i18n>Salutation</span><span i18n> is required</span></mat-error>
					</mat-form-field>
					<mat-form-field flex layout-margin>
						<mat-label i18n>Title</mat-label>
						<input matInput name="title" [(ngModel)]="item.title" placeholder="Title" i18n-placeholder>
					</mat-form-field>
				</div>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formSalutationTitle.valid || isSaving" (click)="patch(['salutation', 'title'])" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Name -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" i18n>Name</mat-panel-title>
				<mat-panel-description>{{item.firstName}} {{item.lastName}}</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formName="ngForm" novalidate>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex="50" layout-margin>
						<mat-label i18n>First name</mat-label>
						<input matInput name="firstName" [(ngModel)]="item.firstName" #firstName="ngModel" required placeholder="First name" i18n-placeholder>
						<mat-error *ngIf="firstName.errors?.required"><span i18n>First name</span><span i18n> is required</span></mat-error>
					</mat-form-field>
					<mat-form-field flex="50" layout-margin>
						<mat-label i18n>Last name</mat-label>
						<input matInput name="lastName" [(ngModel)]="item.lastName" #lastName="ngModel" required placeholder="Last name" i18n-placeholder>
						<mat-error *ngIf="lastName.errors?.required"><span i18n>Last name</span><span i18n> is required</span></mat-error>
					</mat-form-field>
				</div>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formName.valid || isSaving" (click)="patch(['firstName', 'lastName'])" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Email -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" i18n>Email</mat-panel-title>
				<mat-panel-description>{{item.email}}</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formEmail="ngForm" novalidate>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex layout-margin>
						<mat-label i18n>Email</mat-label>
						<input matInput type="email" name="email" [(ngModel)]="item.email" #email="ngModel" readonly="true" required email placeholder="Email" i18n-placeholder>
						<mat-error *ngIf="email.errors?.required"><span i18n>Email</span><span i18n> is required</span></mat-error>
						<mat-error *ngIf="!email.errors?.required && email.errors?.email"><span i18n>Email</span><span i18n> is invalid</span></mat-error>
					</mat-form-field>
				</div>
			</form>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region User name -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" i18n>User name</mat-panel-title>
				<mat-panel-description>{{item.userName}}</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formUser name="ngForm" novalidate>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex layout-margin>
						<mat-label i18n>User name</mat-label>
						<input matInput type="userName" name="userName" [(ngModel)]="item.userName" #userName="ngModel" readonly="true" required userName placeholder="User name" i18n-placeholder>
						<mat-error *ngIf="userName.errors?.required"><span i18n>User name</span><span i18n> is required</span></mat-error>
					</mat-form-field>
				</div>
			</form>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Password -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" i18n>Password</mat-panel-title>
				<mat-panel-description>********</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formPassword="ngForm" novalidate>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex="50" layout-margin>
						<mat-label i18n>Password</mat-label>
						<input matInput [type]="hidePassword ? 'password' : 'text'" name="password" [(ngModel)]="newPassword.password" #password="ngModel" validateEqual="confirmPassword" reverse="true" required minlength="8" [pattern]="passwordPattern" placeholder="Password" i18n-placeholder>
						<button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
							<mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
						</button>
						<mat-error *ngIf="password.errors?.required"><span i18n>Password</span><span i18n> is required</span></mat-error>
						<mat-error *ngIf="password.errors?.pattern" i18n>The password must be at least eight characters, one uppercase letter, one lowercase letter, one digit, and a non-alphanumeric character.</mat-error>
					</mat-form-field>
				</div>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex="50" layout-margin>
						<mat-label i18n>Repeat password</mat-label>
						<input matInput [type]="hidePassword ? 'password' : 'text'" name="confirmPassword" [(ngModel)]="newPassword.confirmPassword" #confirmPassword="ngModel" validateEqual="password" required placeholder="Repeat password" i18n-placeholder>
						<button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
							<mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
						</button>
						<mat-error *ngIf="confirmPassword.errors?.required"><span i18n>Repeat password</span><span i18n> is required</span></mat-error>
						<mat-error *ngIf="!confirmPassword.errors?.validateEqual" i18n>Password and confirmation password do not match</mat-error>
					</mat-form-field>
				</div>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formPassword.valid || isSaving" (click)="changePassword()" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Phone -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" i18n>Phone</mat-panel-title>
				<mat-panel-description>
					<span>{{item.phoneNumber}}</span>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formPhone="ngForm" novalidate>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex layout-margin>
						<mat-label i18n>Phone number</mat-label>
						<input matInput name="phoneNumber" [(ngModel)]="item.phoneNumber" #phoneNumber="ngModel" required placeholder="Phone number" i18n-placeholder>
						<mat-error *ngIf="phoneNumber.errors?.required"><span i18n>Phone number</span><span i18n> is required</span></mat-error>
					</mat-form-field>
				</div>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formPhone.valid || isSaving" (click)="patch(['phoneNumber'])" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Mobile phone -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" i18n>Mobile phone number</mat-panel-title>
				<mat-panel-description>
					<span class="na">{{item.mobilePhoneNumber}}</span>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formMobilePhone="ngForm" novalidate>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex layout-margin>
						<mat-label i18n>Mobile phone number</mat-label>
						<input matInput name="mobilePhoneNumber" [(ngModel)]="item.mobilePhoneNumber" #mobilePhoneNumber="ngModel" placeholder="Mobile phone number" i18n-placeholder>
						<mat-error *ngIf="mobilePhoneNumber.errors?.required"><span i18n>Mobile phone number</span><span i18n> is required</span></mat-error>
					</mat-form-field>
				</div>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formMobilePhone.valid || isSaving" (click)="patch(['mobilePhoneNumber'])" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Birthdate -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" i18n>Birthdate</mat-panel-title>
				<mat-panel-description>{{item.birthdate | date:'dd.MM.yyyy'}}</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formBirthdate="ngForm" novalidate>
				<div layout-gt-sm="row" layout="column">
					<mat-form-field flex layout-margin>
						<mat-label i18n>Birthdate</mat-label>
						<input matInput [matDatepicker]="birthdatePicker" name="birthdate" [(ngModel)]="item.birthdate" #birthdate="ngModel" placeholder="Birthdate" i18n-placeholder>
						<mat-datepicker-toggle matSuffix [for]="birthdatePicker"></mat-datepicker-toggle>
						<mat-datepicker #birthdatePicker></mat-datepicker>
					</mat-form-field>
				</div>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formBirthdate.valid || isSaving" (click)="patch(['birthdate'])" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Connections -->
		<mat-expansion-panel class="wrap" [expanded]="currentPanel === 'connections'" #connectionsPanel>
			<mat-expansion-panel-header>
				<mat-panel-title i18n="@@connections">Connections</mat-panel-title>
				<mat-panel-description *ngIf="connectionsPanel.expanded">
					<span flex></span>
					<a mat-icon-button (click)="$event.stopPropagation(); addConnection();">
						<mat-icon>playlist_add</mat-icon>
					</a>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formConnection="ngForm" novalidate>
				<mat-accordion>
					<mat-expansion-panel class="wrap" *ngFor="let connection of item.connections; let i = index" [expanded]="!connection.id">
						<mat-expansion-panel-header>
							<mat-panel-title>
								<span *ngIf="connection.address?.address1">
									{{connection.address?.address1}}
									{{connection.address?.address2}} -
									{{connection.address?.postalCode}}
									{{connection.address?.city}}
								</span>
								<span *ngIf="!connection.address?.address1" i18n>New line</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<app-customer-connection-form [item]="connection">
							<mat-action-row lineOptionFooter class="bgc-white-4">
								<button mat-flat-button color="primary" [disabled]="!formConnection.valid || isSaving" (click)="patchLineOption(connection)" i18n>Save</button>
								<span flex></span>
							</mat-action-row>
							<mat-action-row activationContactFooter class="bgc-white-4">
								<button mat-flat-button color="primary" [disabled]="!formConnection.valid || isSaving" (click)="patchLineOption(connection)" i18n>Save</button>
								<span flex></span>
							</mat-action-row>
						</app-customer-connection-form>
					</mat-expansion-panel>
				</mat-accordion>
			</form>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Phone book entries -->
		<mat-expansion-panel class="wrap" #phoneBookEntriesPanel (opened)="loadPhoneBookEntries($event)">
			<mat-expansion-panel-header>
				<mat-panel-title i18n>Phone book entries</mat-panel-title>
				<mat-panel-description *ngIf="phoneBookEntriesPanel.expanded">
					<span flex></span>
					<a mat-icon-button (click)="$event.stopPropagation()" (click)="addPhoneBookEntry()">
						<mat-icon>add</mat-icon>
					</a>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<div *ngIf="phoneBookEntries?.length==0" i18n>Click on (+) button to add a new phone book entry</div>
			<mat-accordion multi="false" *ngIf="phoneBookEntries">
				<mat-expansion-panel *ngFor="let phoneBookEntry of phoneBookEntries; let i = index" [expanded]="(i == 0 && phoneBookEntries?.length == 1) || (i > 0 && phoneBookEntries?.length > 1)">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<span *ngIf="phoneBookEntry.id">
								<span *ngIf="phoneBookEntry.phoneNumber">({{phoneBookEntry.phoneNumber.nationalDestinationCode}}) {{phoneBookEntry.phoneNumber.subscriberNumber}}</span>
								<span *ngIf="!phoneBookEntry.phoneNumber">{{phoneBookEntry.person?.givenName}} {{phoneBookEntry.person?.surname}}</span>
							</span>
							<span *ngIf="!phoneBookEntry.id" i18n>New phone book entry</span>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<form #formPhoneBookEntry="ngForm" novalidate>
						<app-phone-book-entry-form [item]="phoneBookEntry"></app-phone-book-entry-form>
					</form>
					<mat-action-row>
						<button mat-flat-button color="primary" [disabled]="!formPhoneBookEntry.valid || isSaving" (click)="savePhoneBookEntry(phoneBookEntry, formPhoneBookEntry)" i18n>Save</button>
						<button mat-button color="warn" [disabled]="isSaving" (click)="removePhoneBookEntry(phoneBookEntry)" i18n>Delete</button>
						<span flex></span>
					</mat-action-row>
				</mat-expansion-panel>
			</mat-accordion>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Sepa Mandate -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" layout="row" layout-align="start center" i18n>Bank data</mat-panel-title>
				<mat-panel-description>{{item.sepa.iban}}, {{item.sepa.bankName}}</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formSepa="ngForm" novalidate>
				<app-sepa-form [item]="item.sepa"></app-sepa-form>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formSepa.valid || isSaving" (click)="patch(['sepa'])" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Billing Address -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" layout="row" layout-align="start center" i18n>Billing address</mat-panel-title>
				<mat-panel-description class="na">
					<app-address-item [address]="item.billingAddress" [showCountry]="false" inline="true"></app-address-item>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formBillingAddress="ngForm" novalidate>
				<app-address-form [address]="item.billingAddress" extended="true"></app-address-form>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formBillingAddress.valid || isSaving" (click)="patch(['billingAddress'])" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->

		<!-- #region Shipping Address -->
		<mat-expansion-panel>
			<mat-expansion-panel-header collapsedHeight="50px">
				<mat-panel-title flex="35" layout="row" layout-align="start center" i18n>Shipping address</mat-panel-title>
				<mat-panel-description class="na">
					<app-address-item [address]="item.shippingAddress" [showCountry]="false" inline="true"></app-address-item>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<form #formShippingAddress="ngForm" novalidate>
				<app-address-form [address]="item.shippingAddress" extended="true"></app-address-form>
			</form>
			<mat-action-row>
				<button mat-flat-button color="primary" [disabled]="!formShippingAddress.valid || isSaving" (click)="patch(['shippingAddress'])" i18n>Save</button>
				<span flex></span>
			</mat-action-row>
		</mat-expansion-panel>
		<!-- #endregion -->
	</mat-accordion>
	<mat-spinner *ngIf="!item && isLoading" diameter="32"></mat-spinner>

	<!-- #region FAQs -->
	<app-faq layout="column" class="push-top pad-top push-bottom pad-bottom" group="Profile" [clientId]="currentUser.clientId"></app-faq>
	<!-- #endregion -->
</div>